"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DmsDateTime = void 0;
var _material = require("@mui/material");
var _react = _interopRequireWildcard(require("react"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
/**
 * @Author: Jean Mira
 * @Date:   2024-03-15 10:09:09
 * @summary: "A man who dares to waste one hour of life 
 * has not discovered the value of life" – Charles Darwin
 */

const DmsDateTime = () => {
  const [dateTime, setDateTime] = (0, _react.useState)(new Date());
  const updateTime = () => {
    setDateTime(new Date());
  };
  (0, _react.useEffect)(() => {
    const interval = setInterval(updateTime, 1000);
    return () => clearInterval(interval);
  }, []);
  const addLeadingZero = number => {
    return number < 10 ? "0".concat(number) : number;
  };
  const formattedDate = "".concat(addLeadingZero(dateTime.getDate()), "/").concat(addLeadingZero(dateTime.getMonth() + 1), "/").concat(dateTime.getFullYear());
  const formattedTime = "".concat(addLeadingZero(dateTime.getHours()), ":").concat(addLeadingZero(dateTime.getMinutes()), ":").concat(addLeadingZero(dateTime.getSeconds()));
  const formattedDateTime = "".concat(formattedDate, " ").concat(formattedTime);
  return /*#__PURE__*/_react.default.createElement(_material.Box, {
    sx: {
      margin: 1
    }
  }, /*#__PURE__*/_react.default.createElement(_material.Typography, null, formattedDateTime));
};
exports.DmsDateTime = DmsDateTime;